import {ShopListComponent} from './shopList.component';

export const shopListRoutes = [
    {
        path: 'shopList',
        component: ShopListComponent
    }
];